"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const providers_1 = require("@mne-core/providers");
const IconComponent_1 = tslib_1.__importDefault(require("./IconComponent"));
const StyledListItem_1 = tslib_1.__importDefault(require("./StyledListItem"));
const useBreakpoints_1 = require("./useBreakpoints");
const utils_1 = require("./utils");
const ArgusMenuLink = ({ kind, href, iconId, label, logger, disableShrinking, ListItemProps, ListItemButtonProps, ListItemIconProps, ListItemTextProps, disableIconOffset, }) => {
    const { isDesktop } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(StyledListItem_1.default, { ...ListItemProps },
        react_1.default.createElement(ListItemButton_1.default, { ...{ component: "a", href: kind === "internalLink" ? (0, providers_1.toSpaUrl)(href) : href, ...ListItemButtonProps } },
            !disableIconOffset && (react_1.default.createElement(ListItemIcon_1.default, { ...{ sx: { minWidth: 0, marginRight: 1 }, ...ListItemIconProps } },
                react_1.default.createElement(IconComponent_1.default, { ...{ iconId, logger, sx: { color: "primary.contrastText", height: "1.2em", width: "1.2em" } } }))),
            (isDesktop || disableShrinking) && (react_1.default.createElement(ListItemText_1.default, { ...{
                    primary: label,
                    sx: { color: "primary.contrastText", pl: (0, utils_1.disableIconOffsetFn)(disableIconOffset, iconId) },
                    primaryTypographyProps: { variant: "button" },
                    ...ListItemTextProps,
                } })))));
};
exports.default = ArgusMenuLink;
